/**
 * Display-side down-payment helpers.
 * 0 is a real value (policy off / unacknowledged) — never treat it as missing.
 */

export function clampDownPaymentPercent(value: unknown): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.min(100, Math.max(0, n));
}

export function resolvedBookingDownPaymentPercent(
  policy?: { enabled?: boolean; percentage?: number } | null
): number {
  if (!policy?.enabled) return 0;
  return clampDownPaymentPercent(policy.percentage);
}

export function getSaveCardDisclaimer(percent: number, amountLabel: string): string {
  if (percent <= 0) {
    return 'Your card will be saved securely. No booking guarantee is required for this booking.';
  }
  return `Your card will be saved securely. No charge now — a ${percent}% booking guarantee (${amountLabel}) is quoted. You will only be charged that amount if you cancel late or no-show; the full service amount is charged when the appointment is completed.`;
}

export function getConfirmDownPaymentDisplay(
  policy?: { enabled?: boolean; percentage?: number } | null,
  totalPrice = 0
): { enabled: boolean; percentage: number; amount: number } {
  const percentage =
    policy?.enabled === true ? clampDownPaymentPercent(policy.percentage) : 0;
  const enabled = percentage > 0;
  const amountRaw = enabled && totalPrice > 0 ? totalPrice * (percentage / 100) : 0;
  const amount = amountRaw > 0 && amountRaw < 0.5 ? 0.5 : amountRaw;
  return { enabled, percentage, amount };
}

export function getLastMinuteCancellationCopy(fee?: number | null): string {
  const amount = Number(fee);
  if (!Number.isFinite(amount) || amount <= 0) {
    return 'No booking guarantee is required, so nothing will be charged if you cancel.';
  }
  return `$${amount.toFixed(2)} will be charged as a cancellation fee.`;
}
